import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'

var Slide = Backbone.Model.extend({

	section: 'briefings',
	domainType: 'slide',

	urlRoot: function() {
		return 'api/briefings/' + this.get('briefingId') + '/slides'
	},

	/**
	 * Returns the URL for the briefing slide, including any persisted UI state that
	 * should be restored.
	 *
	 * @param {String} opt.queryString the current query string that should be parsed
	 * 				for a "state" parameter that will override the slide's
	 * 				previously saved state. This is most useful in exports, where the
	 * 				slide may have had saved state, but the user could also have changed
	 * 				something while viewing the slide.
	 */
	getStatefulUrl: function (opt = {}) {
		let url = this.get('url')

		let state

		let browserState = new URLSearchParams(opt.queryString).get('state')
		if (!_.isEmpty(browserState)) {
			state = browserState
		} else if (!_.isEmpty(this.get('uiState'))) {
			state = this.get('uiState')
		}

		if (opt.routeSuffix) {
			url += opt.routeSuffix
		}

		if (state) {
			url += '?' + $.param({ state })
		}

		return url
	}

})

export default Slide

Slide.__filename__ = 'briefings/slide.js'
